// LIBRERIE/IMPORTS
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

//IMG
import casaImg from "../../../public/assets/images/inHome/casaPiscina.jpg";

const BannerVendi: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section id="bannerValuta" className="space-pt">
      <div className="container-fluid pr-0 ml-auto mr-0">
        <div className="row justify-content-lg-end">
          <div className="col-12 col-lg-12 mb-4 mb-lg-0">
            <div className="red-box p-3 mr-3">
              <h2 className="mb-4 mb-xl-5" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.title') as string }} />
              <p className="mb-4" dangerouslySetInnerHTML={{ __html: t('homePage.sellBanner.para1') as string }} />
            </div>
          </div>
          <div className="col-12 col-lg-10">
            <div className="img-wrapper">
              <img src={casaImg} className="img-fluid" alt={`${t('homePage.sellBanner.imgAlt1')}`} />
              <Link className="btn btn-primary" to="/valutazione">
                <span>{t('homePage.sellBanner.btnText')}</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerVendi;